import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';

interface IGlobalSnackbarStore {
  snackbarVisible: boolean;
  snackbarMessage: string;
  progressCircularVisible: boolean;
  executionArn: string;
}

@Module({
  dynamic: true,
  store,
  name: 'globalSnackbarStore',
  namespaced: true,
})
export default class GlobalSnackbarStore extends VuexModule
  implements IGlobalSnackbarStore {
  public snackbarVisible = false;
  public snackbarMessage = '';
  public progressCircularVisible = false;
  public executionArn = '';

  @Mutation
  public showSnackbar(message: string) {
    this.snackbarVisible = true;
    this.snackbarMessage = message;
  }

  @Mutation
  public hideSnackbar() {
    this.snackbarVisible = false;
    this.snackbarMessage = '';
  }

  @Mutation
  public showProgressCircular() {
    this.progressCircularVisible = true;
  }

  @Mutation
  public hideProgressCircular() {
    this.progressCircularVisible = false;
  }

  @Mutation
  public setExecutionArn(executionArn: string) {
    this.executionArn = executionArn;
  }

  @Mutation
  public resetExecutionArn() {
    this.executionArn = '';
  }

  @Action
  public showSnackbarAction(message: string) {
    this.context.commit('showSnackbar', message);
  }

  @Action
  public hideSnackbarAction() {
    this.context.commit('hideSnackbar');
  }

  @Action
  public showProgressCircularAction() {
    this.context.commit('showProgressCircular');
  }

  @Action
  public hideProgressCircularAction() {
    this.context.commit('hideProgressCircular');
  }

  @Action
  public storeExecutionArnAction(executionArn: string) {
    this.context.commit('setExecutionArn', executionArn);
    localStorage.setItem('executionArn', executionArn);
  }

  @Action
  public retrieveExecutionArnAction() {
    const executionArn = localStorage.getItem('executionArn');
    this.context.commit('setExecutionArn', executionArn);
  }

  @Action
  public resetExecutionArnAction() {
    this.context.commit('resetExecutionArn');
    localStorage.removeItem('executionArn');
  }
}

export const globalSnackbarModule = getModule(GlobalSnackbarStore);
